import { Component } from '@angular/core';
import { AdminGroupsComponent } from './admin-groups/admin-groups.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';

@Component({
	selector: 'app-admin',
	imports: [AdminGroupsComponent, AdminUsersComponent],
	templateUrl: './admin.component.html',
})
export class AdminComponent {}
